

































import { Component, Prop } from 'vue-property-decorator';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import { WorkerDetailsModule } from '@/store/modules/workerDetails';
import WorkerDto from '@/models/Workers/WorkerDto';
import WorkerStatus from '@/models/Workers/WorkerStatus';

@Component({
    name: 'WorkerStatusEdit'
})
export default class extends GiganautVueDialog {
 
	workerStatus = WorkerStatus;

	@Prop({required: true})
  worker: WorkerDto

  async setStatus(status: WorkerStatus) {
    const worker = JSON.parse(JSON.stringify(WorkerDetailsModule.currentWorker));
    if (worker.status !== status) {
      worker.status = status;
      await WorkerDetailsModule.editStatus(worker);
    }
  }
}
